import { render } from "./GatePickup.vue?vue&type=template&id=64579472&scoped=true"
import script from "./GatePickup.vue?vue&type=script&lang=js"
export * from "./GatePickup.vue?vue&type=script&lang=js"

import "./GatePickup.vue?vue&type=style&index=0&id=64579472&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64579472"]])

export default __exports__